<div class="image-cropper-component">
  <input
    #imageSelector
    type="file"
    (change)="fileChangeEvent($event)"
    accept="image/*"
    style="display: none"
  />

  <img
    [src]="imageUrl"
    [appFallbackImage]="defaultImageUrl"
    alt="Image"
    [height]="height"
    [width]="width"
    (click)="imageSelector.click()"
  />

  <div class="action-btns">
    @if (imageUrl != defaultImageUrl) {
      <sui-button variant="secondary" (click)="openCropper()">
        {{ "image-cropper.button.crop-image" | translate }}
      </sui-button>
    }
    @if (imageUrl != defaultImageUrl) {
      <sui-button class="remove-btn" variant="ghost" (click)="removeImage()">
        {{ "image-cropper.button.remove-image" | translate }}
      </sui-button>
    }
  </div>

  @if (cropperOpen) {
    <div class="overlay"></div>
  }

  @if (cropperOpen) {
    <div class="image-cropper-holder">
      <sui-button
        variant="secondary"
        [leadingIcon]="['fas', 'circle-xmark']"
        (click)="closeCropper('close')"
      >
        {{ "btn.close" | translate }}
      </sui-button>
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded($event)"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"
        [imageURL]="imageUrl"
      >
      </image-cropper>
      <sui-button variant="primary" (click)="closeCropper('save')">
        {{ "btn.apply" | translate }}
      </sui-button>
    </div>
  }
</div>
